/**
 * Run async tasks in parallel with a max concurrency limit.
 * @param {Array} items
 * @param {number} limit
 * @param {(item, index) => Promise<any>} worker
 * @returns {Promise<Array>} results (in original order). Failures are captured
 *   as { __error: err } so the caller can inspect per-item outcomes.
 */
export async function runWithConcurrency(items, limit, worker) {
  const results = new Array(items.length);
  let cursor = 0;
  const runners = new Array(Math.min(limit, items.length))
    .fill(0)
    .map(async () => {
      while (cursor < items.length) {
        const idx = cursor++;
        try {
          results[idx] = await worker(items[idx], idx);
        } catch (err) {
          results[idx] = { __error: err };
        }
      }
    });
  await Promise.all(runners);
  return results;
}
